import axios from "axios";
import React, { useState } from "react";

const SendEvent = () => {

  const [name, setName] = useState("");
  const [categories, setCategories] = useState("");
  const [description, setDescription] = useState("");

  const [images, setImages] = useState([""]);

  const [packages, setPackages] = useState([
    {
      eventName: "",
      packages: [
        {
          packageName: "",
          price: "",
          description: "",
          features: "",
          duration: ""
        }
      ]
    }
  ]);

  const [locations, setLocations] = useState([
    { city: "", state: "", venue: "", address: "" }
  ]);

  const [contact, setContact] = useState({
    name: "",
    phone: "",
    email: "",
    whatsapp: ""
  });

  // ---------------- IMAGES ----------------

  const addImage = () => setImages([...images, ""]);

  const updateImage = (i, value) => {
    const updated = [...images];
    updated[i] = value;
    setImages(updated);
  };

  const removeImage = (i) => {
    if (images.length === 1) return;
    setImages(images.filter((_, index) => index !== i));
  };

  // ---------------- EVENT TYPES ----------------

  const addEventType = () => {
    setPackages([
      ...packages,
      {
        eventName: "",
        packages: [
          {
            packageName: "",
            price: "",
            description: "",
            features: "",
            duration: ""
          }
        ]
      }
    ]);
  };

  const updateEventName = (index, value) => {
    const updated = [...packages];
    updated[index].eventName = value;
    setPackages(updated);
  };

  const removeEventType = (index) => {
    if (packages.length === 1) return;
    setPackages(packages.filter((_, i) => i !== index));
  };

  // ---------------- PACKAGES ----------------

  const addPackage = (eventIndex) => {

    const updated = [...packages];

    updated[eventIndex].packages.push({
      packageName: "",
      price: "",
      description: "",
      features: "",
      duration: ""
    });

    setPackages(updated);

  };

  const updatePackage = (eventIndex, packageIndex, field, value) => {

    const updated = [...packages];
    updated[eventIndex].packages[packageIndex][field] = value;
    setPackages(updated);

  };

  const removePackage = (eventIndex, packageIndex) => {

    const updated = [...packages];

    if (updated[eventIndex].packages.length === 1) return;

    updated[eventIndex].packages.splice(packageIndex, 1);

    setPackages(updated);

  };

  // ---------------- LOCATIONS ----------------

  const addLocation = () => {
    setLocations([...locations, { city: "", state: "", venue: "", address: "" }]);
  };

  const updateLocation = (i, field, value) => {
    const updated = [...locations];
    updated[i][field] = value;
    setLocations(updated);
  };

  const removeLocation = (i) => {
    if (locations.length === 1) return;
    setLocations(locations.filter((_, index) => index !== i));
  };

  // ---------------- CONTACT ----------------

  const updateContact = (field, value) => {
    setContact({ ...contact, [field]: value });
  };

  // ---------------- SUBMIT ----------------

  const submitHandler = async (e) => {

    e.preventDefault();

    try {

      const payload = {

        name: name.trim(),

        categories: categories
          .split(",")
          .map(c => c.trim())
          .filter(c => c !== ""),

        description,

        images: images.filter(img => img.trim() !== ""),

        packages: packages
          .filter(e => e.eventName)
          .map(e => ({
            eventName: e.eventName.trim(),
            packages: e.packages
              .filter(p => p.packageName && p.price)
              .map(p => ({
                packageName: p.packageName.trim(),
                price: Number(p.price),
                description: p.description || "",
                features: p.features
                  ? p.features.split(",").map(f => f.trim())
                  : [],
                duration: p.duration || ""
              }))
          })),

        locations: locations.filter(l => l.city),

        contact
      };

      if (!payload.name || payload.categories.length === 0) {
        alert("Event name and categories are required");
        return;
      }

      if (payload.packages.length === 0) {
        alert("At least one event type with package is required");
        return;
      }

      await axios.post("https://ezer-eventapp.onrender.com/events", payload);

      alert("✅ Event created successfully");

    } catch (err) {

      console.error(err);
      alert("❌ Error creating event");

    }

  };

  return (

    <div className="container py-5">

      <h2 className="text-center mb-4">Add Event</h2>

      <form onSubmit={submitHandler}>

        {/* EVENT INFO */}

        <input
          className="form-control mb-3"
          placeholder="Event Name"
          onChange={(e) => setName(e.target.value)}
        />

        <input
          className="form-control mb-3"
          placeholder="Categories (Wedding, Birthday)"
          onChange={(e) => setCategories(e.target.value)}
        />

        <textarea
          className="form-control mb-3"
          placeholder="Event Description"
          onChange={(e) => setDescription(e.target.value)}
        />

        {/* IMAGES */}

        <h5>Images</h5>

        {images.map((img, i) => (

          <div key={i} className="d-flex gap-2 mb-2">

            <input
              className="form-control"
              value={img}
              placeholder="Image URL"
              onChange={(e) => updateImage(i, e.target.value)}
            />

            <button
              type="button"
              className="btn btn-danger"
              onClick={() => removeImage(i)}
            >
              ❌
            </button>

          </div>

        ))}

        <button type="button" className="btn btn-secondary mb-4" onClick={addImage}>
          Add Image
        </button>

        {/* PACKAGES */}

        <h5>Event Packages</h5>

        {packages.map((eventType, eventIndex) => (

          <div key={eventIndex} className="border p-3 mb-4">

            <input
              className="form-control mb-3"
              placeholder="Event Type (Marriage, Birthday)"
              onChange={(e) => updateEventName(eventIndex, e.target.value)}
            />

            {eventType.packages.map((p, packageIndex) => (

              <div key={packageIndex} className="border p-3 mb-2">

                <input
                  className="form-control mb-2"
                  placeholder="Package Name (Basic, Premium)"
                  onChange={(e) =>
                    updatePackage(eventIndex, packageIndex, "packageName", e.target.value)
                  }
                />

                <input
                  className="form-control mb-2"
                  placeholder="Price"
                  onChange={(e) =>
                    updatePackage(eventIndex, packageIndex, "price", e.target.value)
                  }
                />

                <textarea
                  className="form-control mb-2"
                  placeholder="Description"
                  onChange={(e) =>
                    updatePackage(eventIndex, packageIndex, "description", e.target.value)
                  }
                />

                <input
                  className="form-control mb-2"
                  placeholder="Features (comma separated)"
                  onChange={(e) =>
                    updatePackage(eventIndex, packageIndex, "features", e.target.value)
                  }
                />

                <input
                  className="form-control mb-2"
                  placeholder="Duration"
                  onChange={(e) =>
                    updatePackage(eventIndex, packageIndex, "duration", e.target.value)
                  }
                />

                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={() => removePackage(eventIndex, packageIndex)}
                >
                  Remove Package
                </button>

              </div>

            ))}

            <button
              type="button"
              className="btn btn-secondary me-2"
              onClick={() => addPackage(eventIndex)}
            >
              Add Package
            </button>

            <button
              type="button"
              className="btn btn-danger"
              onClick={() => removeEventType(eventIndex)}
            >
              Remove Event Type
            </button>

          </div>

        ))}

        <button
          type="button"
          className="btn btn-dark mb-4"
          onClick={addEventType}
        >
          Add Event Type
        </button>

        {/* LOCATIONS */}

        <h5>Locations</h5>

        {locations.map((l, i) => (

          <div key={i} className="d-flex gap-2 mb-2">

            <input
              className="form-control"
              placeholder="City"
              onChange={(e) => updateLocation(i, "city", e.target.value)}
            />

            <input
              className="form-control"
              placeholder="State"
              onChange={(e) => updateLocation(i, "state", e.target.value)}
            />

            <input
              className="form-control"
              placeholder="Venue"
              onChange={(e) => updateLocation(i, "venue", e.target.value)}
            />

            <input
              className="form-control"
              placeholder="Address"
              onChange={(e) => updateLocation(i, "address", e.target.value)}
            />

            <button
              type="button"
              className="btn btn-danger"
              onClick={() => removeLocation(i)}
            >
              ❌
            </button>

          </div>

        ))}

        <button type="button" className="btn btn-secondary mb-4" onClick={addLocation}>
          Add Location
        </button>

        {/* CONTACT */}

        <h5>Contact Details</h5>

        <input
          className="form-control mb-2"
          placeholder="Contact Name"
          onChange={(e) => updateContact("name", e.target.value)}
        />

        <input
          className="form-control mb-2"
          placeholder="Phone"
          onChange={(e) => updateContact("phone", e.target.value)}
        />

        <input
          className="form-control mb-2"
          placeholder="Email"
          onChange={(e) => updateContact("email", e.target.value)}
        />

        <input
          className="form-control mb-4"
          placeholder="Whatsapp"
          onChange={(e) => updateContact("whatsapp", e.target.value)}
        />

        <button className="btn btn-primary w-100">
          Create Event
        </button>

      </form>

    </div>

  );

};

export default SendEvent;